import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';

export * from './dtos/create-vehicle-category.dto';
export * from './dtos/update-vehicle-category.dto';
export * from './dtos/vehicle-categories-stats.dto';
export * from './dtos/vehicle-category-list.dto';
export * from './dtos/vehicle-category-record.dto';
export * from './dtos/vehicle-category-activity-event.dto';
export * from './dtos/vehicle-category-activity-event-hydration.dto';
export * from './dtos/vehicle-category-search.dto';

export * from './types/vehicle-categories-filters';

export * from './validators/schemas/create-vehicle-category.schema';
export * from './validators/schemas/update-vehicle-category.schema';

export const vehicleCategoryValidators = {
  canCreateOrUpdate,
};
